import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { SERVICE_ID_ROUTE_PARAM } from '@core/routes/utils/route-param';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngrx/store';
import { servicesAuthorizations } from '@stores/profile/profile.selectors';
import { NEW_CONSENTS_PROCESS_BLACK_LIST } from '@stores/service-authorization/new-authorization-process-blacklist';
import { selectIfDefined } from '@stores/utils/selects.operators';
import { map } from 'rxjs';

export const isServiceInactive: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);

  const serviceId = route.paramMap.get(SERVICE_ID_ROUTE_PARAM);
  const contentId = route.queryParamMap.get('contentId');
  const isFromWidget = route.queryParamMap.get('from') === 'widget';

  if (!serviceId) return false;

  if (!NEW_CONSENTS_PROCESS_BLACK_LIST.find((item) => item === serviceId)) {
    return true;
  }

  return selectIfDefined(store, servicesAuthorizations).pipe(
    map((services) => {
      if (!services.find((authorization) => authorization.applicationId === serviceId)) {
        return true;
      }

      window.open(
        `${FeaturesRoutingEnum.Redirect}/${serviceId}?contentId=${contentId}`,
        isFromWidget ? '_self' : '_blank',
        'noreferrer noopener'
      );

      return true;
    })
  );
};
